import invariant from 'assert'
import { Flex } from '@chakra-ui/react'

import FormInputMultiCheckbox from '@/components/UI/Form/FormInput/FormInputMultiCheckbox'
import type { FormInputType } from '@/components/UI/Form/types'

export default function OnboardingInputGrayCheckboxMulti({
  input,
}: {
  input: FormInputType
}): React.ReactElement {
  invariant.ok(input.type === 'multi-checkbox')

  return (
    <Flex backgroundColor="bg.subtle" p={2} rounded="md">
      <FormInputMultiCheckbox input={input} />
    </Flex>
  )
}
